<template>
  <div class="widget-config">
    <el-form label-suffix="：" style="padding-bottom: 30px"
            v-if="this.data && Object.keys(this.data).length > 0"
            label-width="100px" label-position="left">
      <el-form-item label="类型" style="display:none;">
        <el-select v-model="data.type"
                   placeholder="请选择类型"
                   @change="handleChangeType">
          <el-option-group v-for="group in fields"
                           :key="group.title"
                           :label="group.title">
            <el-option v-for="item in group.list"
                       :key="item.type"
                       :label="item.label"
                       :value="item.type">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
        <el-form-item label="属性值">
          <el-input v-model="data.prop"
                    placeholder="属性值"></el-input>
        </el-form-item>
        <el-form-item label="标题" v-if="data.type !== 'hyperLink'">
          <el-input v-model="data.label"
                    placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item label="标题" v-else>
          <el-input v-model="data.title"
            placeholder="标题"></el-input>
        </el-form-item>
        <qrcode v-if="data.type == 'qrcode'" :data="data" :widgetForm="widgetForm" />
        <div v-else>
        <el-form-item label="标题排列（手机）" v-if="isTitleAlign(data.type)">
          <el-radio-group v-model="data.titleAlign" size="small" @change="saveAlign">
            <el-radio-button label="horizontal">横向排列</el-radio-button>
            <el-radio-button label="vertical">纵向排列</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="校验接口" v-if="['area'].includes(data.type)">
          <el-input v-model="data.verifyUrl"
            placeholder="校验接口"></el-input>
        </el-form-item>
        <el-form-item label="校验方式" label-width="110px" v-if="['area'].includes(data.type)"
        >
          <el-select v-model="data.verifyType" placeholder="">
            <el-option label="强制校验" value="force"></el-option>
            <el-option label="提示性校验" value="prompt"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地图精度" label-width="110px" v-if="['position','area'].includes(data.type)"
        >
          <el-select v-model="data.addressType" placeholder="">
            <el-option label="详细地址" value="address"></el-option>
            <el-option label="道路" value="road"></el-option>
            <el-option label="区" value="district"></el-option>
            <el-option label="市" value="city"></el-option>
            <el-option label="省" value="province"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否必填" v-if="['position','area'].includes(data.type)">
          <el-switch v-model="data.required"></el-switch>
        </el-form-item>
        <el-form-item label="精确范围" v-if="['position','area'].includes(data.type)">
          <el-input v-model="data.scope"
                    placeholder="精确范围"></el-input>
        </el-form-item>
        <el-form-item label="范围内提示" label-width="110px" v-if="['area'].includes(data.type)"
        >
          <el-input v-model="data.tip1"
            placeholder="范围内提示"></el-input>
        </el-form-item>
        <el-form-item label="范围外提示" label-width="110px" v-if="['area'].includes(data.type)"
        >
          <el-input v-model="data.tip2"
            placeholder="范围外提示"></el-input>
        </el-form-item>
        <el-form-item label="列排序" v-if="data.subfield">
          <el-switch v-model="data.sortable"></el-switch>
        </el-form-item>
        <el-form-item label="列筛选" v-if="data.subfield">
          <el-switch v-model="data.filters"></el-switch>
        </el-form-item>
        <el-form-item label="固定列" v-if="data.subfield">
          <el-select v-model="data.fixed" clearable placeholder="">
            <el-option label="左边固定" value="left"></el-option>
            <el-option label="右边固定" value="right"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字（手机）" v-if="data.subfield && !['dynamic','ueditor','upload','divider','hyperLink','caption', 'calculateFormula'].includes(data.type)">
          <el-switch v-model="data.isKeyword"></el-switch>
        </el-form-item>
        <el-form-item label="选项排列（手机）" v-if="data.type === 'radio' || data.type === 'checkbox'">
          <el-radio-group v-model="data.direction" size="small" @change="saveDirection">
            <el-radio-button label="horizontal">横向排列</el-radio-button>
            <el-radio-button label="vertical">纵向排列</el-radio-button>
          </el-radio-group>
          <el-input-number v-if="data.direction === 'horizontal'" v-model="data.horNum" :min="0" :max="5" label="列" size="small" />
        </el-form-item>
        <el-form-item label="手机直拍" v-if="data.type === 'upload'">
          <el-switch v-model="data.camera"></el-switch>
        </el-form-item>
        <el-form-item label="设为标题" v-if="!data.subfield && !['dynamic','ueditor','upload','divider','hyperLink','caption', 'calculateFormula','position','area', 'signature'].includes(data.type)">
          <el-switch v-model="data.isDataTitle" @change="switchChange"></el-switch>
        </el-form-item>
        <el-form-item label="设为摘要" v-if="!data.subfield && !['dynamic','ueditor','upload','divider','hyperLink','caption','position','area', 'signature'].includes(data.type)">
          <el-switch v-model="data.isSummary"></el-switch>
        </el-form-item>
        <!-- <el-form-item label="审批概要" v-if="!data.subfield && ['select','radio'].includes(data.type)">
          <el-switch v-model="data.shortOpinion"></el-switch>
        </el-form-item> -->
        <el-form-item label="宽度"
                      v-if="data.subfield">
          <el-input-number v-model="data.width"
                          controls-position="right"
                          placeholder="宽度"
                          :min="100"></el-input-number>
        </el-form-item>
        <el-form-item label="合并单元格" v-if="data.subfield">
          <el-switch v-model="data.merge"></el-switch>
        </el-form-item>
        <el-form-item label="表单栅格"
                      v-if="!data.subfield || data.parentIsTable">
          <el-input-number v-model="data.span"
                          controls-position="right"
                          placeholder="表单栅格"
                          :min="6"
                          :max="24"></el-input-number>
        </el-form-item>
        <el-form-item label="偏移量">
          <el-input v-model="data.offset"
            placeholder="偏移量"></el-input>
        </el-form-item>
        <component :is="getComponent" :data="data" :widgetForm="widgetForm"></component>
        <!-- 是否触发自定义事件 -->
          <el-form-item label="自定义事件" v-if="!['divider','hyperLink','caption', 'calculateFormula','ueditor','position','area','dynamic', 'signature','licensePlate'].includes(data.type)">
            <el-switch v-model="data.customEvent"></el-switch>
          </el-form-item>
          <el-form-item label="事件名"  v-if="data.customEvent">
            <el-input placeholder="请输入函数名称" v-model="data.customEventName"></el-input>
          </el-form-item>
        <!-- 是否显示为过程字段 -->
        <el-form-item label="屏蔽过程" v-if="!['dynamic','ueditor','upload','divider','hyperLink','caption', 'signature'].includes(data.type)">
          <el-switch v-model="data.shieldProcessRecord"></el-switch>
        </el-form-item>
        <!-- 为空只读不显示字段 -->
        <el-form-item label="为空不显示" v-if="!['dynamic','divider','hyperLink','caption'].includes(data.type)">
          <el-switch v-model="data.noDisplayIfNull"></el-switch>
        </el-form-item>
        <el-form-item label="居左布局" v-if="!['dynamic','divider','ueditor','upload', 'signature'].includes(data.type)">
          <el-switch v-model="data.layoutOnLeft"></el-switch>
        </el-form-item>
        <el-form-item label="数据留存" v-if="!['dynamic','divider','ueditor','upload', 'signature'].includes(data.type)">
          <el-tooltip content="动态显隐控制的组件，被隐藏时数据默认会被清空，如需要留存，请开启此功能！" placement="top">
            <el-switch v-model="data.dynamicHideNotClear"></el-switch>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="是否联系人" v-if="['input','checkbox'].includes(data.type)">
          <el-switch v-model="data.isContactPerson"></el-switch>
        </el-form-item>

        <template v-if="['signature'].includes(data.type)">
        <el-divider content-position="left">excel导出参数</el-divider>
        <el-form-item label="起始行">
          <el-input-number v-model="data.excelRow1"
          placeholder="" />
        </el-form-item>
        <el-form-item label="起始列">
          <el-input-number v-model="data.excelCol1"
          placeholder="" />
        </el-form-item>
        <el-form-item label="结束行">
          <el-input-number v-model="data.excelRow2"
          placeholder="" />
        </el-form-item>
        <el-form-item label="结束列">
          <el-input-number v-model="data.excelCol2"
          placeholder="" />
        </el-form-item>
        <el-form-item label="起始x坐标">
          <el-input-number v-model="data.startX" :max="255" :min="0"
          placeholder="" />
        </el-form-item>
        <el-form-item label="起始y坐标">
          <el-input-number v-model="data.startY" :max="255" :min="0"
          placeholder="" />
        </el-form-item>
        <el-form-item label="结束x坐标">
          <el-input-number v-model="data.endX" :max="255" :min="0"
          placeholder="" />
        </el-form-item>
        <el-form-item label="结束y坐标">
          <el-input-number v-model="data.endY" :max="255" :min="0"
          placeholder="" />
        </el-form-item>
        <el-divider content-position="left">pdf导出参数</el-divider>
        <el-form-item label="左边距">
        <el-input-number v-model="data.pdfPaddingLeft"
        placeholder="左边距" />
        </el-form-item>
        <el-form-item label="下边距">
        <el-input-number v-model="data.pdfPaddingBottom"
        placeholder="下边距" />
        </el-form-item>
        <el-form-item label="宽度">
        <el-input-number v-model="data.pdfImgWidth"
        placeholder="宽度" />
        </el-form-item>
        <el-form-item label="高度">
        <el-input-number v-model="data.pdfImgHeight"
        placeholder="高度" />
        </el-form-item>
        </template>
      </div>
    </el-form>
    <avue-empty v-else
                desc="拖拽字段进行配置"
                style="margin-top: 100%;"></avue-empty>
  </div>
</template>

<script>
import configInput from './config/input'
import configTextarea from './config/textarea.vue'
import configNumber from './config/number.vue'
import configDynamic from './config/dynamic.vue'
import configSwitch from './config/switch.vue'
import configRate from './config/rate.vue'
import configSlider from './config/slider.vue'
import configColor from './config/color.vue'
import configRadio from './config/radio.vue'
import configCheckbox from './config/checkbox.vue'
import configSelect from './config/select.vue'
import configCascader from './config/cascader.vue'
import configTree from './config/tree.vue'
import configDate from './config/date.vue'
import configUpload from './config/upload.vue'
import ConfigUeditor from './config/ueditor.vue'
import configMap from './config/map.vue'
import configWebMap from './config/webMap.vue'
import configLicensePlate from './config/licensePlate.vue'
import configDivider from './config/divider.vue'
import configGeneral from './config/general.vue'
import configFlowUserChoose from './config/flowUserChoose.vue'
import configHyperLink from './config/hyperLink.vue'
import configPopUpWindow from './config/popUpWindow.vue'
import configCaption from './config/caption.vue'
import configTemplateFile from './config/templateFile.vue'
import configSignature from './config/signature.vue'
import qrcode from './config/qrcode.vue'
import configCalculateFormula from './config/calculator'
import { isTitleAlign } from '@/workFlow/utils/form.js'

import fields from './fieldsConfig.js'

const dateArr = [
  'year', 'month', 'week', 'date', 'datetime', 'time', 'daterange', 'timerange', 'datetimerange', 'dates'
]

export default {
  name: 'WidgetConfig',
  props: ['data', 'widgetForm'],
  components: { configInput, configCascader, configCheckbox, configColor, configDate, configDivider, configDynamic, configGeneral, configMap, configWebMap, configLicensePlate, configNumber, configRadio, configRate, configSelect, configSlider, configSwitch, configTextarea, configTree, ConfigUeditor, configUpload, configFlowUserChoose, configHyperLink, configPopUpWindow, configCaption, configCalculateFormula, qrcode, configTemplateFile, configSignature },
  data() {
    return {
      fields,
      oldFormTitleExpression: ''
    }
  },
  computed: {
    getComponent() {
      const prefix = 'config-'
      const { type } = this.data
      let result = 'input'

      if ([undefined, 'input', 'password'].includes(type)) result = 'input'
      else if (dateArr.includes(type)) result = 'date'
      else result = type

      console.log(result)

      return prefix + result
    }
  },

  methods: {
    isTitleAlign,
    saveAlign(val) {
      this.widgetForm.column
        .filter(item => item.label == this.data.label)
        .forEach(item => { item.titleAlign = val })
    },
    saveDirection(val) {
      this.widgetForm.column
        .filter(item => item.label == this.data.label)
        .forEach(item => { item.direction = val })
    },
    switchChange(flag) {
      if (flag) {
        if (!this.oldFormTitleExpression || this.oldFormTitleExpression === '') {
          this.oldFormTitleExpression = this.widgetForm.formTitleExpression
        }
        this.widgetForm.formTitleExpression = '${' + this.data.prop + '}'
        this.widgetForm.column
          .filter(item => item.prop !== this.data.prop)
          .filter(item => item.isDataTitle)
          .forEach(item => { item.isDataTitle = false })
      } else {
        if (this.oldFormTitleExpression === '${' + this.data.prop + '}') {
          this.widgetForm.formTitleExpression = ''
        } else {
          this.widgetForm.column
            .filter(item => '${' + item.prop + '}' === this.oldFormTitleExpression)
            .forEach(item => { item.isDataTitle = true })
          this.widgetForm.formTitleExpression = this.oldFormTitleExpression
        }
      }
    },
    async handleChangeType(type) {
      if (type) {
        const config = await this.getConfigByType(type)
        config.prop = this.data.prop
        for (let key in config) {
          if (config.hasOwnProperty(key) && !['icon', 'label', 'span'].includes(key)) {
            const val = config[key]
            this.$set(this.data, key, val)
          }
        }
      }
    }
  }
}
</script>
